import { Grid, Typography, withStyles } from '@material-ui/core';
import { BlocTextes, Button, Card, Modale, Select, Snack } from 'bc-front-sagacomponents';
import { useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { formatDateCourt } from '../../../helpers/formatters';
import { AdhesionAdherentParticulierResponse } from '../../../services/Api/swagger';
import Adherent from '../InformationsTab/Adherent';
import { useAvantage } from '../hooks/avantage';
import styles from '../style';
import { ResiliationFormData, useResiliationForm } from './selectors';
import { buildResiliationList } from './helpers';

interface Props {
  classes?: any;
  selectedAdhesion?: AdhesionAdherentParticulierResponse;
}
const ResiliationContent = (props: Props) => {
  const { classes, selectedAdhesion } = props;

  const { selectedProgramme } = useAvantage();

  const {
    methods,
    watch,
    handleSubmit,
    setValue,
    fetching,
    errorApi,
    setParamsResiliationForm,
    setResiliationEnvoyee,
    resiliationEnvoyee,
    register,
    errors,
  } = useResiliationForm(selectedAdhesion);

  const onSubmit = (data) => {
    setParamsResiliationForm({ ...data });
  };

  const handleChange = (id: keyof ResiliationFormData, value: string) => {
    methods.clearErrors();
    setValue(id, value);
  };

  const [openConfirmationResiliation, setOpenConfirmationResiliation] = useState<boolean>(false);

  const handleOpenModaleConfirm = () => {
    const data = methods.watch();
    if (data.raisonResiliation) {
      setOpenConfirmationResiliation(true);
    } else {
      methods.setError('raisonResiliation', { type: 'required' });
    }
  };
  const handleCloseModaleConfirm = () => {
    setOpenConfirmationResiliation(false);
  };
  const handleSubmitModaleConfirm = () => {
    handleCloseModaleConfirm();
    const data = methods.watch();
    onSubmit(data);
  };

  useEffect(() => {
    register('raisonResiliation', { required: true });
  }, [register]);

  useEffect(() => {
    methods.reset();
  }, [selectedAdhesion?.numeroAdhesion]);
  return (
    <div className={classes.blocResiliation}>
      <Card>
        <Adherent selectedAdhesionId={selectedAdhesion?.numeroAdhesion} />

        <BlocTextes
          red
          title=" "
          content={[
            {
              title: 'Adhésion',
              value: selectedAdhesion?.numeroAdhesion,
            },
            {
              title: 'Produit',
              value: selectedProgramme?.libelle,
            },
            {
              title: 'Véhicule',
              value:
                selectedAdhesion?.immatriculation,
            },
            {
              title: 'Vendu par',
              value: selectedAdhesion?.nomClient,
            },
            {
              title: 'Le',
              value: selectedAdhesion?.dateEffet && formatDateCourt(selectedAdhesion?.dateEffet),
            },
          ]}
        />

        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} id="resiliationForm">
            <Grid container alignItems="flex-start" className={classes.resiliationformBottom}>
              <Select
                name="raisonResiliation"
                options={buildResiliationList}
                required
                value={watch('raisonResiliation')}
                onChange={handleChange}
                label="Raison de la résiliation"
                errors={errors.raisonResiliation}
              />
              <Button variant="contained" color="primary" title={'Valider'} onClick={handleOpenModaleConfirm}></Button>
            </Grid>

            {!fetching && errorApi && (
              <Typography color="error">
                {errorApi?.response?.data?.description || 'Une erreur est survenue, veuillez ressayer ultérieurement'}
              </Typography>
            )}
            {resiliationEnvoyee && (
              <Snack
                onClose={() => setResiliationEnvoyee(false)}
                type="success"
                message="Votre demande a bien été transférée, vous allez recevoir un mail récapitulatif de votre demande"
              />
            )}
          </form>
        </FormProvider>
      </Card>
      <Modale
        open={openConfirmationResiliation}
        onConfirm={handleSubmitModaleConfirm}
        onCancel={handleCloseModaleConfirm}
        buttonValidText="Confirmer"
        fetchingConfirm={fetching}
        centerButtons
      >
        <Grid container direction="column" alignItems="center" className={classes.resiliationModale}>
          <Typography variant="h3">Confirmation d'envoi de la demande</Typography>
          <Typography variant="h4">
            Êtes-vous sûr(e) de vouloir demander la résiliation de votre <strong>{selectedProgramme?.libelle}</strong>
            {' '}concernant le véhicule{' '}
            <strong>
              {selectedAdhesion?.immatriculation}
            </strong>{' '}
            ?<br /><br />
            L'effectivité de la résiliation est conditionnée aux cas prévus par le contrat et par la loi en vigueur.
            Nous vous rappelons que la résiliation ne pourra être acceptée qu'après validation de votre demande par nos équipes de gestion.
            Nos équipes de gestion reviendront vers vous pour valider les modalités de résiliation au regard des conditions prévues par votre contrat.
          </Typography>
        </Grid>
      </Modale>
    </div>
  );
};
export default withStyles(styles)(ResiliationContent);
